import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "quotewizard" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "fieldleft" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "textheader" }, "Notice of Adverse Underwriting Decision", -1)
const _hoisted_10 = { class: "responsemessage" }
const _hoisted_11 = ["innerHTML"]

import { onMounted, computed } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import { scrollTop } from "@/utils/Utils";

const title = "Notice of adverse";

export default /*#__PURE__*/_defineComponent({
  __name: 'QuoteDeniedGeneric',
  setup(__props) {

const quote = useQuoteStore();

onMounted(() => {
  scrollTop();
  quote.done = true;
});

const date = computed(() => {
  const today = new Date();
  return today.toLocaleDateString();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createTextVNode(_toDisplayString(_unref(quote).address.firstName) + " " + _toDisplayString(_unref(quote).address.lastName), 1),
        _hoisted_6,
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_unref(quote).address.address), 1),
          _hoisted_7,
          _createTextVNode(" " + _toDisplayString(_unref(quote).address.city) + ", " + _toDisplayString(_unref(quote).address.state.short) + " " + _toDisplayString(_unref(quote).address.zip), 1)
        ])
      ]),
      _hoisted_8,
      _hoisted_9,
      _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(quote).responseMessage), 1),
      _createElementVNode("div", {
        innerHTML: _unref(quote).denialNotice
      }, null, 8, _hoisted_11)
    ])
  ]))
}
}

})